import React, { FC } from 'react';
import { Container, ContentLoader } from './styles';
import { Props } from './types';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 400 30"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <rect x="12" y="11" rx="3" ry="3" width="30" height="6" />
        <circle cx="106" cy="13" r="2" />
        <rect x="111" y="10" rx="3" ry="3" width="25" height="6" />
        <rect x="200" y="10" rx="3" ry="3" width="31" height="6" />
        <rect x="240" y="10" rx="3" ry="3" width="31" height="6" />
        <rect x="295" y="10" rx="3" ry="3" width="31" height="6" />
        <rect x="335" y="10" rx="3" ry="3" width="31" height="6" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
